const OPTION_TRANSLATIONS_EN = {
  bianco: 'White',
  bianca: 'White',
  nero: 'Black',
  nera: 'Black',
  grigio: 'Grey',
  grigia: 'Grey',
  diffusa: 'Diffuse',
  opale: 'Opal',
  satinata: 'Satin',
  trasparente: 'Clear',
  'bianco esterno interno oro': 'White exterior, gold interior',
  'nero esterno interno oro': 'Black exterior, gold interior',
};

const DESCRIPTION_REPLACEMENTS_EN = [
  [/\bElegante\b/gi, 'Elegant'],
  [/\bapparecchio di illuminazione tecnica\b/gi, 'technical lighting fixture'],
  [/\bapparecchi di illuminazione\b/gi, 'lighting fixtures'],
  [/\bmini faretto\b/gi, 'mini spotlight'],
  [/\bfaretto\b/gi, 'spotlight'],
  [/\bsegnapasso\b/gi, 'step light'],
  [/\bsospensione\b/gi, 'pendant'],
  [/\bsospesione\b/gi, 'suspension'],
  [/\bapplique\b/gi, 'wall light'],
  [/\bincasso\b/gi, 'recessed'],
  [/\bparete\b/gi, 'wall'],
  [/\bsoffitto\b/gi, 'ceiling'],
  [/\brealizzat[ao] in alluminio e acciaio\b/gi, 'made of aluminum and steel'],
  [/\brealizzat[ao] in alluminio\b/gi, 'made of aluminum'],
  [/\balluminio tornito\b/gi, 'machined aluminum'],
  [/\bDisponibile in diverse finiture\b/gi, 'Available in different finishes'],
  [/\bdisponibile in varie finiture colore\b/gi, 'available in different color finishes'],
  [/\bDiverse finiture disponibili\b/gi, 'Different finishes available'],
  [/\bDiponibile in varie dimensioni e finiture\b/gi, 'Available in various sizes and finishes'],
  [/\bDiponibile in varie dimensioni\b/gi, 'Available in various sizes'],
  [/\bdiponibile in varie lunghezze\b/gi, 'available in various lengths'],
  [/\bdisponibile in varie lunghezze\b/gi, 'available in various lengths'],
  [/\bdiponibile\b/gi, 'available'],
  [/\bdisponibile\b/gi, 'available'],
  [/\bambienti residenziali e commerciali\b/gi, 'residential and commercial environments'],
  [/\bambient[ei] residenzial[ei]\b/gi, 'residential environments'],
  [/\bambient[ei] commercial[ei]\b/gi, 'commercial environments'],
  [/\binstallazione a superficie\b/gi, 'surface installation'],
  [/\binstallazioni\b/gi, 'installations'],
  [/\binstallazione\b/gi, 'installation'],
  [/\bsuerficie\b/gi, 'surface'],
  [/\binstsllazione\b/gi, 'installation'],
  [/\borientabile\b/gi, 'adjustable'],
  [/\bmonoemissione\b/gi, 'single emission'],
  [/\bbiemissione\b/gi, 'double emission'],
  [/\bfornit[oa] con\b/gi, 'supplied with'],
  [/\bideale per\b/gi, 'ideal for'],
  [/\baree verdi\b/gi, 'green areas'],
  [/\bgiardini\b/gi, 'gardens'],
  [/\bparchi\b/gi, 'parks'],
  [/\bvialetti\b/gi, 'pathways'],
  [/\bcorridoi\b/gi, 'corridors'],
  [/\bscalini\b/gi, 'steps'],
  [/\bcapannoni\b/gi, 'industrial buildings'],
  [/\bstrade\b/gi, 'roads'],
  [/\bpiazzali\b/gi, 'courtyards'],
  [/\bnicchie\b/gi, 'niches'],
  [/\bcieli stellati\b/gi, 'starry ceilings'],
  [/\bcartongesso\b/gi, 'plasterboard'],
  [/\bflangia\b/gi, 'flange'],
  [/\bdiametro\b/gi, 'diameter'],
  [/\bDiamentro\b/gi, 'Diameter'],
  [/\bdametro\b/gi, 'diameter'],
  [/\bDimensione\b/gi, 'Size'],
  [/\bdimensione\b/gi, 'size'],
  [/\bdimensioni\b/gi, 'sizes'],
  [/\bSezione\b/gi, 'Section'],
  [/\bsezione\b/gi, 'section'],
  [/\bcilindrica\b/gi, 'cylindrical'],
  [/\bcubica\b/gi, 'cubic'],
  [/\bas anello\b/gi, 'ring-shaped'],
  [/\bfrontalino intercambiabile\b/gi, 'interchangeable front panel'],
  [/\brosoncino superiore\b/gi, 'upper canopy'],
  [/\bpenisole\b/gi, 'kitchen islands'],
  [/\btavoli\b/gi, 'tables'],
  [/\bGenerale\b/gi, 'general'],
  [/\bindiustriale\b/gi, 'industrial'],
  [/\bfiassaggio\b/gi, 'spring fixing'],
];

const PRODUCT_OVERRIDES_EN = {
  GL2800W2: {
    name: 'Elena',
    description: 'Elegant single-emission wall light in aluminum, suitable for residential and commercial installations.',
  },
  'GL 2820SS': {
    name: 'Rex Mini',
    description: 'Cylindrical technical ceiling fixture in machined aluminum, available in different finishes.',
  },
  'GL 282200': {
    name: 'Rex Square',
    description: 'Rectangular technical ceiling fixture in machined aluminum, available in different finishes.',
  },
  'GL 2820': {
    name: 'Rex',
    description: 'Cylindrical technical ceiling fixture in aluminum, available in different finishes.',
  },
  'GL 3007#II': {
    name: 'Telemaco Mini',
    description: 'Adjustable mini spotlight for external recessed installation on ceiling or wall, in machined aluminum.',
  },
  'GL 300700': {
    name: 'Telemaco Ghost',
    description: 'Trimless plasterboard recessed mini spotlight with housing box, made of machined aluminum.',
  },
  'GL 122803': {
    name: 'Elettra',
    description: 'Adjustable mini spotlight for external recessed installation on ceiling or wall, in machined aluminum.',
  },
  'GL 3009#PE': {
    name: 'Telemaco Pendant',
    description: 'Technical mini pendant for ceiling installation, in machined aluminum.',
  },
  'GL 2023#XX': {
    name: 'Cylinder 60',
    description: 'Technical ceiling pendant, H 600 mm D 35 mm, in machined aluminum with front diffusing PMMA disc.',
  },
  GL2052T6: {
    name: 'SoftLine',
    description: 'Contemporary indirect-light element with 15 mm tensioned steel strip for wall-to-wall or floor-to-ceiling installation. LED strip and driver are not included.',
  },
  GL2026B0: { name: 'Beat Mini 1200', description: 'Elegant linear single-emission aluminum pendant, section 38x38, available in different lengths.' },
  GL2026B1: { name: 'Beat Mini 1600', description: 'Elegant linear single-emission aluminum pendant, section 38x38, available in different lengths.' },
  GL2026B2: { name: 'Beat Mini 2000', description: 'Elegant linear single-emission aluminum pendant, section 38x38, available in different lengths.' },
  GL2121B0: { name: 'Lulin 1200', description: 'Elegant linear single-emission aluminum pendant, section 20x20, available in different lengths and finishes.' },
  GL2021B1: { name: 'Lulin 1600', description: 'Elegant linear single-emission aluminum pendant, section 20x20, available in different lengths and finishes.' },
  GL2021B2: { name: 'Lulin 2000', description: 'Elegant linear single-emission aluminum pendant, section 20x20, available in different lengths and finishes.' },
  GL2029C1: { name: 'Magnum Slim 1500', description: 'Linear single-emission aluminum fixture with integrated driver for ceiling installation, size 38x90x1500.' },
  GL2029C2: { name: 'Magnum Slim 2000', description: 'Linear single-emission aluminum fixture with integrated driver for ceiling installation, size 38x90x2000.' },
  GL2029C3: { name: 'Magnum Slim 3000', description: 'Linear single-emission aluminum fixture with integrated driver for ceiling installation, size 38x90x3000.' },
  GL2029D1: { name: 'Slim Pendant 1500', description: 'Linear double-emission aluminum fixture with integrated driver, size 38x90x1500.' },
  GL2029D3: { name: 'Slim Pendant 3000', description: 'Linear double-emission aluminum fixture with integrated driver, size 38x90x3000.' },
  GL205106: { name: 'Saturno 60', description: 'Ring-shaped single-emission aluminum fixture with integrated driver, outer diameter 66 cm.' },
  GL205109: { name: 'Saturno 90', description: 'Ring-shaped single-emission aluminum fixture with integrated driver, outer diameter 90 cm.' },
  GL205112: { name: 'Saturno 120', description: 'Ring-shaped single-emission aluminum fixture with integrated driver, outer diameter 120 cm.' },
  GL2840Z3: { name: 'Gipsy 300', description: 'Double-emission aluminum wall light, section 90x35x300, available in different lengths.' },
  GL2840Z6: { name: 'Gipsy 600', description: 'Double-emission aluminum wall light, section 90x35x600, available in different lengths.' },
  GL2840Z9: { name: 'Gipsy 900', description: 'Double-emission aluminum wall light, section 90x35x900, available in different lengths.' },
  GL2830I6: { name: 'Woody', description: 'Double-emission aluminum wall light, section 10x10x10, available in different color finishes.' },
  'GL 2XXXS': { name: 'Parentesi S', description: 'Ultra-flat double-emission wall light with interchangeable wooden front panel.' },
  'GL 2XXXM': { name: 'Parentesi M', description: 'Ultra-flat double-emission wall light with interchangeable wooden front panel.' },
  'GL 2XXXL': { name: 'Parentesi L', description: 'Ultra-flat double-emission wall light with interchangeable wooden front panel.' },
  'GL 122201': { name: 'Galatea 1', description: 'Compact IP67 in-ground recessed spotlight in machined aluminum.' },
  'GL 122901': { name: 'Galatea Power', description: 'Compact IP67 recessed spotlight in machined aluminum, up to 4.5W.' },
  'GL 122203': { name: 'Galatea 3', description: 'Medium-size IP67 in-ground recessed spotlight in machined aluminum.' },
  'GL 1230F6': { name: 'Ione 6', description: 'IP67 in-ground recessed spotlight with steel flange.' },
  'GL 122504': { name: 'Teti', description: 'IP67 recessed step light with aluminum or stainless-steel flange.' },
  'GL 126001': { name: 'Xante', description: 'Cubic outdoor fixture for surface installation, supplied with spike for gardens, parks and green areas.' },
  'GL 12061A': { name: 'Spot 350', description: 'Urban lighting fixture, height 350 cm, ideal for pathways, parks and green areas.' },
  'GL 12061B': { name: 'Spot 600', description: 'Urban lighting fixture, height 600 cm, ideal for pathways, parks and green areas.' },
  'GL 12051A': { name: 'Castello 1', description: 'Urban lighting fixture, H 100 cm, with one independently adjustable LED module and ground base.' },
  'GL 12052B': { name: 'Castello 2', description: 'Urban lighting fixture with two independently adjustable LED modules and ground base.' },
  'GL 12053C': { name: 'Castello 3', description: 'Urban lighting fixture, H 300 cm, with three independently adjustable LED modules and ground base.' },
  'GL 1220C1': { name: 'Cyclope', description: 'Compact elegant IP67 outdoor projector in aluminum, supplied with spike for gardens and parks.' },
  'GL 290701': { name: 'Jazz', description: 'Mini aluminum spotlight, outer diameter 25 mm, for niches and starry ceiling applications.' },
  'GL 290401': { name: 'Blazer 1', description: 'Mini aluminum spotlight with optics, outer diameter 30 mm, for niches and starry ceilings.' },
  'GL 291003': { name: 'Buck 3', description: 'Ultra-flat mini aluminum spotlight with optics, 70x20 mm, ideal for furniture and low-clearance niches.' },
  'GL 290403': { name: 'Blazer 3', description: 'Aluminum spotlight with recessed light source and optics, external flange 70 mm.' },
  'GL 290405': { name: 'Blazer 5', description: 'Aluminum spotlight with recessed light source and optics, external flange 70 mm.' },
  'GL 290406': { name: 'Blazer 6', description: 'Aluminum spotlight with recessed light source and optics, external flange 120 mm.' },
  'GL 2901N2': { name: 'Hornet 12', description: 'Recessed aluminum fixture with 12 crown-arranged LEDs and recessed source, external flange 200 mm.' },
  'GL 29062R': { name: 'Grizzly', description: 'Plasterboard recessed spotlight, external diameter 70 mm, for general lighting in homes and shops.' },
  'GL 29062G': { name: 'Grizzly 2G', description: 'Plasterboard recessed spotlight with 40 mm recessed source and external driver included.' },
  'GL 2904G3': { name: 'Blazer 3 Ghost', description: 'Square trimless plasterboard recessed spotlight with recessed source, supplied with housing box (cod. 900200).' },
  'GL 2904G5': { name: 'Blazer 5 Ghost', description: 'Square trimless plasterboard recessed spotlight with recessed source, supplied with housing box.' },
  'GL 290301': { name: 'Bull 1', description: 'Adjustable mini plasterboard recessed spotlight with spring fixing, in machined aluminum, diameter 50 mm.' },
  'GL 290303': { name: 'Bull 3', description: 'Adjustable plasterboard recessed spotlight with spring fixing, in machined aluminum, diameter 90 mm.' },
  'GL 2054PE': { name: 'Nordic', description: 'Elegant aluminum suspension, diameter 221 mm, ideal for kitchen tables and islands.' },
  'GL 2055PE': { name: 'Tulipano', description: 'Elegant aluminum suspension with internal cylinder and 14-micron gold-plated canopy, ideal for islands and tables.' },
  'GL 281400': { name: 'Stinky', description: 'Aluminum step light, suitable for stairs and corridor lighting.' },
  'GL 315204': { name: 'Ariel 4', description: 'Industrial fixture in aluminum and steel for asymmetric lighting of sports areas and large halls.' },
  'GL 315206': { name: 'Ariel 6', description: 'Industrial fixture in aluminum and steel for asymmetric lighting of sports areas and large halls.' },
  'GL 313460': { name: 'Gemini 60', description: 'Industrial high-bay fixture in aluminum and steel for sports areas and industrial buildings.' },
  '3134#96': { name: 'Gemini 96', description: 'Industrial high-bay fixture in aluminum and steel for sports areas and industrial buildings.' },
  'GL 313424': { name: 'Gemini 24', description: 'Industrial high-bay fixture in aluminum and steel for sports areas and industrial buildings.' },
  'GL3134#92': { name: 'Gemini 2X96', description: 'Industrial high-bay fixture in aluminum and steel for sports areas and industrial buildings.' },
  'GL3134#93': { name: 'Gemini 3X96', description: 'Industrial high-bay fixture in aluminum and steel for sports areas and industrial buildings.' },
  'GL 3112#24': { name: 'Giotto', description: 'Industrial fixture for warehouse and industrial lighting applications.' },
  'GL 3133#00': { name: 'Nuovaluce', description: 'Industrial bell-type fixture for offices, entrances and similar spaces.' },
  'GL 100204 ': { name: 'Zeus', description: 'Street-light fixture for outdoor lighting of roads, courtyards and external areas.' },
  300702: { name: 'Telemaco', description: 'Mini Telemaco spotlight D30x76 mm, 6W, 24V.' },
  '3009001M': { name: 'Telemaco Slim', description: 'Telemaco Slim D30x155 mm, 10W, 24V.' },
  'Telemaco pendente': { name: 'Telemaco Pendant', description: 'Minimal pendant D30x115 mm.' },
  GL2041: { name: 'SenzaFine', description: 'SenzaFine light line, section 20x20 mm.' },
  GL2043: { name: 'Oslo', description: 'Adjustable cylindrical fixture for 360° diffused lighting.' },
  'Nordic-24': { name: 'Nordic Suspension', description: 'Nordic D221 x H220 mm, 10W, 24V.' },
  '30080113': { name: 'Telemaco MAX', description: 'Telemaco 25W, 230V.' },
  'Sospensione Nordic-230': { name: 'Nordic Suspension', description: 'Nordic D221 x H220 mm, 10W, 230V.' },
  'Telemaco pendente-230': { name: 'Telemaco Pendant', description: 'Minimal pendant D30x115 mm, 230V.' },
};

const normalizeText = (value) =>
  String(value ?? '')
    .replace(/Ã‚Â°|Â°/g, '°')
    .replace(/\s+/g, ' ')
    .trim();

const isNonEmptyText = (value) => typeof value === 'string' && normalizeText(value).length > 0;

const normalizeLang = (lang) => String(lang || 'it').toLowerCase().slice(0, 2);

const getFallbackLangs = (lang) => {
  const normalized = normalizeLang(lang);
  return Array.from(new Set([normalized, 'en', 'it']));
};

const getLocalizedFromValue = (value, lang) => {
  if (value == null) return '';

  if (typeof value === 'string' || typeof value === 'number') {
    return normalizeText(value);
  }

  if (Array.isArray(value)) {
    return '';
  }

  if (typeof value === 'object') {
    const fallbacks = getFallbackLangs(lang);
    for (const code of fallbacks) {
      const candidate = value[code];
      if (isNonEmptyText(candidate)) {
        return normalizeText(candidate);
      }
    }
    for (const code of fallbacks) {
      const longCode = code === 'it'
        ? 'it-IT'
        : code === 'en'
          ? 'en-US'
          : code === 'de'
            ? 'de-DE'
            : code === 'es'
              ? 'es-ES'
              : code === 'fr'
                ? 'fr-FR'
                : null;
      if (longCode && isNonEmptyText(value[longCode])) {
        return normalizeText(value[longCode]);
      }
    }
  }

  return '';
};

const getLocalizedField = (record, baseKeys, lang) => {
  if (!record || !Array.isArray(baseKeys)) return '';

  const fallbacks = getFallbackLangs(lang);
  const containers = [record, record.translations, record.i18n].filter(Boolean);

  for (const baseKey of baseKeys) {
    for (const container of containers) {
      const directValue = container?.[baseKey];
      const localizedDirect = getLocalizedFromValue(directValue, lang);
      if (localizedDirect) return localizedDirect;
    }

    for (const code of fallbacks) {
      for (const container of containers) {
        const suffixedValue = container?.[`${baseKey}_${code}`];
        if (isNonEmptyText(suffixedValue)) {
          return normalizeText(suffixedValue);
        }
      }
    }
  }

  return '';
};

const applyEnglishReplacements = (value) => {
  let translated = normalizeText(value);
  DESCRIPTION_REPLACEMENTS_EN.forEach(([pattern, replacement]) => {
    translated = translated.replace(pattern, replacement);
  });
  return translated;
};

export const localizeCatalogProductName = (product, lang) => {
  if (!product) return '';

  const explicitLocalizedName = getLocalizedField(product, ['name'], lang);
  if (explicitLocalizedName) return explicitLocalizedName;

  if (normalizeLang(lang) !== 'it') {
    const override = PRODUCT_OVERRIDES_EN[String(product.id)];
    if (isNonEmptyText(override?.name)) return normalizeText(override.name);
  }

  return normalizeText(product.name);
};

export const localizeCatalogProductDescription = (product, lang) => {
  if (!product) return '';

  const localizedDescription = getLocalizedField(product, ['description', 'descrizione'], lang);
  if (localizedDescription) return localizedDescription;

  const base = normalizeText(product.descrizione || product.description || '');
  if (normalizeLang(lang) === 'it') return base;

  const override = PRODUCT_OVERRIDES_EN[String(product.id)];
  if (override?.description) return normalizeText(override.description);

  const explicitEnglish = normalizeText(product.description_en || product.descrizione_en || '');
  if (explicitEnglish) return explicitEnglish;

  return applyEnglishReplacements(base);
};

export const localizeCatalogOptionValue = (value, lang) => {
  const text = getLocalizedFromValue(value, lang) || normalizeText(value);
  if (normalizeLang(lang) === 'it') return text;
  const mapped = OPTION_TRANSLATIONS_EN[text.toLowerCase()];
  return mapped || applyEnglishReplacements(text);
};

export const localizeCatalogFreeText = (value, lang) => {
  const text = getLocalizedFromValue(value, lang) || normalizeText(value);
  if (normalizeLang(lang) === 'it') return text;
  return applyEnglishReplacements(text);
};
